import { Component } from '@angular/core';

@Component({
    selector: 'ins-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.css'],
    standalone: false
})
export class NotFoundComponent {

  constructor() { }

}
